import { useNavigate } from 'react-router-dom';
import './Notfound.css'; 

function NotFound() {
  const navigate = useNavigate();

 

  return (
    <div className="not-found-container">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <button onClick={() => navigate("/")}>Go back home</button>
    </div>
  );
}

export default NotFound;
